import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const ContactCards = () => {
  const sectionRef = useRef(null);

  const officeAddress =
    "Sr. No. 2373, Sim Vistar, At & Po-Pij, Ta-Vaso, Dist-Nadiad, Gujarat 387230";

  // Updated to use your specific Google Maps link
  const getGoogleMapsUrl = () => {
    return `https://maps.app.goo.gl/tiV5X6iswanxS1B46`;
  };

  const contactData = [
    {
      id: 1,
      icon: "/images/contect/location.png",
      text: officeAddress,
      isLocation: true,
    },
    {
      id: 2,
      icon: "/images/contect/mail.png",
      texts: ["info@utpannllp.com"],
      link: "mailto:info@utpannllp.com",
    },
    {
      id: 3,
      icon: "/images/contect/call.png",
      texts: ["+91 86 45 88 88 81"],
      link: "tel:+918645888881",
    },
  ];

  useEffect(() => {
    const context = gsap.context(() => {
      // Text Animations
      const textElements = gsap.utils.toArray(
        sectionRef.current.querySelectorAll(".animated-text-content"),
      );

      textElements.forEach((element) => {
        gsap.set(element, {
          y: 25,
          opacity: 0,
          clipPath: "inset(100% 0 0% 0)",
        });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: element.closest(".animated-card-container"),
            start: "top 85%",
            end: "center 60%",
            scrub: 1,
          },
        });

        tl.to(element, {
          y: 0,
          opacity: 1,
          clipPath: "inset(0% 0 0% 0)",
          duration: 1,
          ease: "power2.out",
        });
      });

      // Card Animations
      const cardElements = gsap.utils.toArray(
        sectionRef.current.querySelectorAll(".animated-card-container"),
      );

      cardElements.forEach((card) => {
        gsap.set(card, {
          y: 50,
          opacity: 0,
        });

        gsap.to(card, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: card,
            start: "top 95%",
            end: "center 70%",
            scrub: 1,
          },
        });
      });
    }, sectionRef);

    return () => context.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="w-full max-w-[1612px] mx-auto px-4 sm:px-6 lg:px-8"
    >
      <div className="flex flex-col lg:flex-row gap-[25px] md:gap-[37px] lg:gap-[50px] w-full">
        {contactData?.map((item) => (
          <div
            key={item?.id}
            className="flex flex-col gap-[15px] md:gap-[22px] lg:gap-[30px] justify-center items-center w-full lg:w-[504px] h-auto bg-[#1c233a] rounded-[30px] pt-[52px] md:pt-[78px] lg:pt-[104px] px-[28px] md:px-[42px] lg:px-[56px] pb-[52px] md:pb-[78px] lg:pb-[104px] animated-card-container"
          >
            <img
              src={item?.icon}
              alt="Contact Icon"
              className="w-[30px] h-[30px] sm:w-[45px] sm:h-[45px] md:w-[52px] md:h-[52px] lg:w-[60px] lg:h-[60px]"
            />

            <div className="flex flex-col justify-start items-center w-full">
              {item?.text ? (
                <div className="flex flex-col items-center gap-4">
                  <p
                    className="text-[20px] sm:text-[24px] md:text-[27px] lg:text-[30px] font-bold leading-[28px] sm:leading-[33px] md:leading-[39px] lg:leading-[44px] text-center text-white whitespace-pre-line animated-text-content"
                    style={{ fontFamily: "Sora" }}
                  >
                    {item?.text}
                  </p>

                  {/* Clicking this will now open your specific Google Maps location */}
                  {item.isLocation && (
                    <a
                      href={getGoogleMapsUrl()}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-4 text-[14px] sm:text-[16px] text-[#4285F4] hover:underline font-medium animated-text-content cursor-pointer"
                    >
                      View larger map
                    </a>
                  )}
                </div>
              ) : (
                item?.texts?.map((text, index) => (
                  <a
                    key={index}
                    href={item.link}
                    className="text-[20px] sm:text-[24px] md:text-[27px] lg:text-[30px] font-bold leading-[26px] sm:leading-[30px] md:leading-[34px] lg:leading-[38px] text-center text-white animated-text-content hover:opacity-80 transition-opacity"
                    style={{ fontFamily: "Sora" }}
                  >
                    {text}
                  </a>
                ))
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ContactCards;
